import { render } from "./Compare.vue?vue&type=template&id=4c70d183&scoped=true"
import script from "./Compare.vue?vue&type=script&lang=ts"
export * from "./Compare.vue?vue&type=script&lang=ts"

import "./Compare.vue?vue&type=style&index=0&id=4c70d183&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c70d183"

export default script